import type {AppData, BIEvent, PS} from '@wix/document-services-types'
import {guidUtils} from '@wix/santa-core-utils'
import {generateApplicationId} from '@wix/document-manager-utils'
import tpaErrors from '../bi/errors'
import appMarketService from '../services/appMarketService'

const cacheAppMarketDataAfterProvision = function (ps: PS, appData: AppData) {
    // eslint-disable-next-line promise/prefer-await-to-then
    appMarketService.getAppMarketDataAsync(ps, appData.appDefinitionId).catch(() => {
        ps.siteAPI.reportBI(tpaErrors.FAIL_TO_GET_APP_MARKET_DATA as BIEvent)
    })
}

const generateAppFlowsLargestAppId = (currentLargest: number) => generateApplicationId(currentLargest, guidUtils.random)

export default {
    cacheAppMarketDataAfterProvision,
    generateAppFlowsLargestAppId
}
